import {
  ColumnData,
  Colors,
  NewAsset,
  SlideAction,
  Spacing,
  TopModalBar,
  useSlidePanel,
} from '@gripp/shared-ui';
import { useMemo, useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { HeaderResetButton } from '../../shared/components/headerResetButton';
import { MediaPicker } from '../../shared/components/media/mediaPicker';
import EditGroup from './editGroup';

export const AssetNew = () => {
  const navigate = useNavigate();
  const [selectedGroups, setSelectedGroups] = useState<
    Array<{ id: string; name: string }>
  >([]);
  const [isGroupsPanelOpen, setIsGroupsPanelOpen] = useState(false);
  const resetGroupsRef = useRef<(() => void) | undefined>(undefined);

  const rightColumn = useMemo<ColumnData>(
    () => ({
      title: 'asset.newAsset',
      showBackButton: true,
      backButtonTransition: SlideAction.SINGLE,
      onBackButtonPress: () => navigate('/assets'),
      mainComponent: (
        <NewAsset
          onCancel={() => navigate('/assets')}
          mediaPicker={MediaPicker}
          topComponentBar={TopModalBar}
          styles={styles}
          onSaved={(assetId: string) => {
            navigate(`/assets/${assetId}`);
          }}
          selectedGroups={selectedGroups}
          onGroupsChange={setSelectedGroups}
          onSelectorEdit={() => setIsGroupsPanelOpen(true)}
        />
      ),
      disableScroll: true,
    }),
    [navigate, selectedGroups]
  );

  const thirdColumn = useMemo<ColumnData | null>(() => {
    if (!isGroupsPanelOpen) return null;
    return {
      title: 'asset.groups',
      mainComponent: (
        <EditGroup
          selectedGroups={selectedGroups}
          onGroupsChange={setSelectedGroups}
          resetRef={resetGroupsRef}
        />
      ),
      headerComponent: (
        <View style={styles.headerResetButton}>
          <HeaderResetButton onReset={() => resetGroupsRef.current?.()} />
        </View>
      ),
      showBackButton: true,
      disableScroll: true,
      onBackButtonPress: () => setIsGroupsPanelOpen(false),
    };
  }, [isGroupsPanelOpen, selectedGroups]);

  useSlidePanel('right', rightColumn, [rightColumn]);
  useSlidePanel('third', thirdColumn, [thirdColumn]);

  return null;
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.role.canvas,
    flex: 1,
  },
  contentContainer: {
    flex: 1,
    paddingHorizontal: Spacing.basePadding.paddingHorizontal,
    paddingVertical: Spacing.basePadding.paddingVertical,
  },
  headerResetButton: {
    marginRight: 8,
  },
});
